import { PaginationState } from '@tanstack/react-table';
import { z } from 'zod';
export interface UserErrorDto {
	error: string;
	databaseName: string;
}
export type GetAllUsersResponse = {
	allUsers: Workday[];
	errors: UserErrorDto[];
	total:number;
};

export const fetchUsers = async (
	username: string,
	allUsers: boolean,
	pagination: PaginationState,
): Promise<GetAllUsersResponse> => {
	try {
		const res = await fetch('/Workday/search', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				name: username,
				allUsers: allUsers,
				pageIndex: pagination.pageIndex,
				pageSize: pagination.pageSize,
			}),
		});
		const data = await res.json()
return {
	allUsers: data.data?.allUsers || [],
	errors: data.data?.errors || [],
	total:data.total || 0,
};
	} catch (error) {
		return {
			allUsers: [],
			errors: [{ error: 'Error fetching users', databaseName: '' }],
			total:0,
		};
	}
};

export const update = async (workday: Workday[]): Promise<boolean> => {
	const requestBody: UpdateUsersRequest = { Users: workday };
	const res = await fetch(`/Workday`, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(requestBody),
	});
	return res.ok;
};

export const WorkdaySchema = z.object({
	id: z.number(),
	userId: z.string().optional(),
	username: z.string().nonempty({ message: 'Username is required' }),
	workdayId: z.string().optional(),
	addDate: z.date().optional(),
	modDate: z.date().optional(),
	aimInstance: z.string().nonempty({ message: 'Instance name is required' }),
	ignore: z.boolean().optional(),
	activeFlag: z.string().optional(),
	teamId: z.string().optional(),
});

export type Workday = z.infer<typeof WorkdaySchema>;
export type UpdateUsersRequest = { Users: Workday[] };
